const MutationTypes = Object.freeze({
  SET_FEEDBACK_MSG: 'SET_FEEDBACK_MSG',
  SET_FEEDBACK_CALLOUT_FLAG: 'setFeedbackCalloutFlag',
});
const storageModule = {
  namespaced: true,
  state: {
    lastPlp: null,
    bikeTechSKU: null,
    feedbackMsg: '',
    showFeedbackCallout: false,
    purchaseMode: localStorage.purchaseMode ? localStorage.purchaseMode : false,
    usersTouchedAllocatedItems: [],
  },
  getters: {
    purchaseMode(state) {
      return state.purchaseMode;
    },
    hasUserTouchedAllocatedItems(state) {
      return state.usersTouchedAllocatedItems.some(
        ({email, b2bUnit}) => email === ACC?.customVariables?.currentUserEmail && b2bUnit === ACC.currentB2BUnit
      );
    },
    /**
     * Gets the window location object. Combines the pathname and searh
     * to handle plp path and search queries
     * @returns concatenated pathname and search
     */
    getPlpLocationUrl() {
      const loc = window.location;
      const locConcat = `${loc.pathname}${loc.search}`;
      return locConcat;
    },
  },
  mutations: {
    setBikeTechSKU(state, sku) {
      state['bikeTechSKU'] = sku;
    },
    setLastPlp(state, payload) {
      state.lastPlp = payload;
    },
    setPurchaseMode(state, value) {
      state['purchaseMode'] = value;
    },
    [MutationTypes.SET_FEEDBACK_MSG](state, message) {
      state.feedbackMsg = message;
    },
    addUserTouchedAllocatedItems(state) {
      state.usersTouchedAllocatedItems.push({
        email: ACC?.customVariables?.currentUserEmail,
        b2bUnit: ACC.currentB2BUnit,
      });
    },
    removeUserTouchedAllocatedItems(state) {
      state.usersTouchedAllocatedItems = state.usersTouchedAllocatedItems.filter(
        ({email, b2bUnit}) => !(email === ACC?.customVariables?.currentUserEmail && b2bUnit === ACC.currentB2BUnit)
      );
    },
    [MutationTypes.SET_FEEDBACK_CALLOUT_FLAG](state, flag = false) {
      state.showFeedbackCallout = flag;
    },
  },
  actions: {
    setFeedbackMsg({commit}, message) {
      commit(MutationTypes.SET_FEEDBACK_MSG, message);
    },
    togglePurchaseMode({commit, state}) {
      let value = !state.purchaseMode;
      commit('setPurchaseMode', value);
    },
    updateLastPlp({commit, getters}) {
      commit('setLastPlp', getters.getPlpLocationUrl);
    },
  },
};

export default storageModule;
